import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { AppPages } from '../../../common/routing/app-navigator';
import Summary from '../../../elements/Summary/Summary';
import { toggleFiltersPanel } from '../store-actions/pipeline-issues-store-actions';
import PipelineIssuesStore from '../stores/pipeline-issues-store';

const ResolvedIssuesSummaryContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { totalFilteredIssues, totalIssues } = useSnapshot(PipelineIssuesStore);
  return (
    <Summary
      headerText='Pipeline Issues'
      linkText='Show Pipeline Summary'
      linkUrl={AppPages.PipelineSummary}
      navComponent={NavLink}
      count={totalFilteredIssues}
      total={totalIssues}
      onCollapse={toggleFiltersPanel}
    />
  );
};

export default ResolvedIssuesSummaryContainer;
